<template>
  <Container class="w-full">
    <div class="grid gap-6 md:grid-cols-2">
      <CardTtfPromo
        v-for="(card, j) in cards"
        :key="j"
        :index="j"
        :title="card.title"
        :copy="card.copy"
        :subtitle="card.subtitle"
        :images="card.images"
        :background-color="card.backgroundColor"
        :full-width="card.fullWidth" />
    </div>
    <ButtonBase
      v-if="cta"
      :label="cta.title"
      :type="cta.type"
      :href="cta.href"
      class="relative z-20 mx-auto mt-6 w-fit lg:mt-12"
      @click="handleClick(cta.href)" />
  </Container>
</template>

<script setup lang="ts">
  import { useNuxtApp } from '#imports'

  import type { TtfPromoCardSet } from '~/models/cards'

  defineProps<TtfPromoCardSet>()

  const { $event: trackEvent } = useNuxtApp()

  function handleClick(url: string) {
    return trackEvent('Link', { props: { 'TTF Promo card set': url } })
  }
</script>
